import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const OrderDetailMainContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const SetsItemsCotainer = styled.div`
    display: flex;
    width: 48.5%;
    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const BillingSubmittedCotainer = styled.div`
    width: 811px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const BillingSubmittedSubCotainer = styled.div`
    display: flex;
    width: 785px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 0.5px solid #d1d1d1;
    border-radius: 10px;
    opacity: 1;
    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const AccountGridContainer = styled(Grid)`
    width: 811px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    padding-bottom: 16px;
    margin: ${({ margin }) => margin};
    ${media.mobileDevice`
    width: auto;
    
    `}
    ${media.mediumDevice`
    width: auto;
   
    `}
    ${media.smalDevice`
    width: auto;
    
    `}
`;

export const AccountGrid = styled(Grid)``;

export const AccountDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: ${({ isDemi }) => (isDemi ? '16px' : '12px')};
    color: ${({ isDemi }) => (isDemi ? '#3C3C3C' : '#000000')};
    margin-top: ${({ isDemi }) => (isDemi ? '16px' : '20px')};
    opacity: 1;
    margin-left: 0px;
    align-items: flex-end;
    ${media.mobileDevice`
margin-top : 17px;
margin-left : 3px;
    `}
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
`;

export const AccountTimeDetails = styled.div`
    text-align: right;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: ${({ isDemi }) => (isDemi ? '16px' : '12px')};
    color: ${({ isDemi }) => (isDemi ? '#3C3C3C' : '#000000')};
    margin-top: ${({ isDemi }) => (isDemi ? '16px' : '20px')};
    opacity: 1;
    margin-left: 0px;
    align-items: flex-end;
    margin-right: 12px;
    ${media.mobileDevice`
        margin-top : 5px;
        margin-left : 16px;
        text-align: left;
    `}
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
`;

export const AccountSubGridContainer = styled(Grid)`
    margin-left: 12px;
    margin-right: 12px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 0.5px solid #d1d1d1;
    padding: ${({ isConsignment }) =>
        isConsignment ? '0rem 0.7rem 0.8rem 0.7rem' : '0.7rem'};
    border-radius: 10px;
    margin-top: 18px;
    ${media.mediumDevice`
        padding:  ${({ isConsignment }) =>
            isConsignment ? '0rem 0.7rem 0.8rem 0.7rem' : '0.7rem'};
    `}
    ${media.mobileDevice`    
    padding-bottom: ${({ mbPaddingBottom }) =>
        mbPaddingBottom ? mbPaddingBottom : '16px'};
        padding: 0.7rem;
    `}
`;

export const AccountSubGrid = styled(Grid)`
    margin-right: ${({ marginRight }) => (marginRight ? '18px' : '0px')};
    &.PriceGrid {
        @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
            margin-right: 18px;
        }
    }
`;

export const AccountTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #585858;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 16px;
    margin-left: ${({ isConsignment }) => (isConsignment ? '-20px' : '0px')};
    
    @media screen and (min-width: 901px) and (max-width: 1024px) {
        margin-right: 12px;
        justify-content: flex-end;
        margin-left: ${({ isConsignment }) =>
            isConsignment ? '-3.5rem' : '0px'};
    }
    
    @media screen and (min-width: 650px) and (max-width: 900px) {
        margin-right: 12px;
        justify-content: flex-end;
        margin-left: ${({ isConsignment }) =>
            isConsignment ? '-1.5rem' : '0px'};
    }
    
    ${media.smalDevice`
        justify-content:center;
    `}
    ${media.mobileDevice`    
        display : none;
    `}
`;

export const AccountMobileTitle = styled.div`
    display: none;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #585858;
    letter-spacing: 0px;
    opacity: 1;
    text-align: right;
    margin-top: 16px;
    margin-right: 12px;
    justify-content: flex-end;
    ${media.mobileDevice`    
        display: block;
        text-align: right;
        margin-top: 0;
        margin-right: 0;
    `}
`;

export const AccountBillingDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '12px')};
    color: ${({ isDemi }) => (isDemi ? '#140F4B' : '#585858')};
    opacity: ${({ isDemi }) => (isDemi ? '1' : '0.7')};
    ${media.mobileDevice`
        display : ${({ isConsignment, isDemi }) =>
            isConsignment && isDemi && 'flex'};
        margin-left: ${({ isConsignment, isRegular }) =>
            isConsignment && isRegular && '30px'};
        align-items: center;
    `}
`;

export const AccountOrderDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 13px;
    color: #585858;
    white-space: ${({ whitespace }) => (whitespace ? whitespace : 'normal')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '16px')};
    opacity: 1;
    margin-left: 5px;
    ${media.mediumDevice`
    margin-left: 7px;
    `}
    ${media.smalDevice`
    margin-left: ${({ IsConsignmentBillingOrder }) =>
        IsConsignmentBillingOrder ? '6px' : '12px'};
    `}
    ${media.mobileDevice`
        margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '12px')};
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop ? mbMarginTop : '16px'};
    `}
`;

export const AccountOrderDiv = styled.div`
    display: flex;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : 'flex-end')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    justify-content: ${({ justifyContent }) => justifyContent};

    ${media.mobileDevice`
    display: none;
    `}
`;
export const AccountOrderMobileDiv = styled.div`
    display: none;
    align-items: flex-end;
    justify-content: ${({ isConsignment }) =>
        isConsignment ? 'flex-end' : ''};
    ${media.mobileDevice`
    display :flex;
    justify-content: flex-start;
    `}
`;

export const PriceTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    color: #654adc;
    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
    margin-top: 16px;
    ${media.mediumDevice`
    text-align: right;
    margin-right : 12px;
    `}
    ${media.smalDevice`
    text-align: right;
    margin-right : 12px;
    `}
    ${media.mobileDevice`    
    text-align: right;
    margin-right : 12px;
    `}
`;
export const AccountStatusDetails = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 17px;
    margin-left: 12px;
    ${media.mobileDevice`
    margin-left:1rem;
    `}
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
    margin-left:1rem;
    `}
`;

export const InvoiceCreatedDetail = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
    font-family: 'AvenirNextWorld Regular';
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;

    ${({ isCreatedDate }) =>
        isCreatedDate &&
        css`
            &:before,
            &:after {
                content: ' | ';
            }
        `}

    ${({ isCreatedDateBy }) =>
        isCreatedDateBy &&
        css`
            &:after {
                content: ' | ';
                opacity: 20%;
            }
        `}
`;

export const WrapperContainer = styled.div`
    display: flex;
    width: ${({ width }) => width};
    max-width: ${({ maxWidth }) => maxWidth};
    ${media.smalDevice`
    width: auto;
        max-width:unset;
        `}
`;

export const ImageContainer = styled.div`
    ${media.mobileDevice`
         margin-left: ${({ isConsignment }) => (isConsignment ? '0' : '11px')};
         margin-bottom: -7px;
         margin-right: ${({ isConsignment }) => isConsignment && '5px'};
    `}
`;

export const CartActionItems = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    opacity: 1;
    display: flex;
    flex-direction: row;
    margin: 2% 2% 2% 4.5%;
    height: ${({ height }) => (height ? height : '20px')};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    white-space: nowrap;
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 20px;
    `}
`;